import { useField, useFormikContext } from "formik";
import { useCallback } from "react";

export const useExclusiveField = (field: string, exclusiveFields: string[], required?: boolean) => {
  const [{ value }, , { setValue }] = useField(field);
  const { setFieldValue } = useFormikContext()

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    if (checked || !required) {
      exclusiveFields.forEach(field => {
        setFieldValue(field, undefined);
      })
      setValue(checked);
    }
  }, [setFieldValue, setValue, required, exclusiveFields]);

  return { value, onChange }
}